import { ArrowForwardIos } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React from 'react';
import { DOTS, usePagination } from "./usePagination.js";
import { IconButton } from "../iconButton/IconButton.js";
import styles from "./Pagination.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Pagination({
  totalCount,
  pageSize,
  currentPage,
  siblingCount,
  onPageChange
}) {
  const paginationRange = usePagination({
    totalCount,
    pageSize,
    currentPage,
    siblingCount
  }) ?? [];

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }
  const onNext = () => {
    onPageChange(currentPage + 1);
  };
  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };
  const lastPage = paginationRange[paginationRange.length - 1];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.paginationContainer,
    children: [/*#__PURE__*/_jsx(IconButton, {
      icon: /*#__PURE__*/_jsx(ArrowForwardIos, {
        className: styles.arrowLeft
      }),
      small: true,
      toolbar: true,
      disabled: currentPage === 1,
      onClick: onPrevious
    }), paginationRange?.map((pageNumber, index) => {
      // Render our Page Pills
      return /*#__PURE__*/_jsx(IconButton, {
        small: true,
        toolbar: pageNumber !== currentPage,
        className: classNames(styles.iconButton, {
          [styles.dotsButtonDisabled]: pageNumber.toString().includes(DOTS)
        }, {
          [styles.currentSelectedPage]: pageNumber === currentPage
        }),
        icon: pageNumber.toString(),
        onClick: () => {
          if (typeof pageNumber === 'string') {
            return;
          }
          onPageChange(pageNumber);
        }
      }, index);
    }), /*#__PURE__*/_jsx(IconButton, {
      icon: /*#__PURE__*/_jsx(ArrowForwardIos, {}),
      small: true,
      toolbar: true,
      disabled: currentPage === lastPage,
      onClick: onNext
    })]
  });
}